// extracted by mini-css-extract-plugin
module.exports = {"slider":"SliderWrap-module__slider___a4cqn","metrics":"SliderWrap-module__metrics___fnRX1"};